import React, { useState } from "react";
import NavCategoryList from "./NavCategory";
import NavSubCategoryList from "./NavSubCategory";
import NavFormList from "./NavForm";
import PermissionList from "./Permission";
import RolePermissionList from "./RolePermission";
import UserRoleList from "./UserRoles";

function UserAuthMainSetup() {
  const [activeTab, setActiveTab] = useState("User_Auth");
  const username = localStorage.getItem("username");
  return (
    <>
      <h2 className="page-heading mb-2 fs-7">User Auth</h2>
      <div className="card">
        <div className="card-body">
          <ul className="nav nav-underline mb-3 custom-nav-tabs">
            {username === "superadmin" ? (
              <li className="nav-item">
                <button
                  className={`nav-link ${
                    activeTab === "org-category" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("org-category")}
                >
                  Category
                </button>
              </li>
            ) : (
              <>
                <li className="nav-item">
                  <button
                    className={`nav-link ${
                      activeTab === "org-category" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("org-category")}
                  >
                    Category
                  </button>
                </li>
              </>
            )}
            {username === "superadmin" ? (
              <li className="nav-item">
                <button
                  className={`nav-link ${
                    activeTab === "org-sub-category" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("org-sub-category")}
                >
                  SubCategory
                </button>
              </li>
            ) : (
              <>
                <li className="nav-item">
                  <button
                    className={`nav-link ${
                      activeTab === "org-sub-category" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("org-sub-category")}
                  >
                    SubCategory
                  </button>
                </li>
              </>
            )}
            {username === "superadmin" ? (
              <li className="nav-item">
                <button
                  className={`nav-link ${
                    activeTab === "org-form" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("org-form")}
                >
                  Form
                </button>
              </li>
            ) : (
              <>
                <li className="nav-item">
                  <button
                    className={`nav-link ${
                      activeTab === "org-form" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("org-form")}
                  >
                    Form
                  </button>
                </li>
              </>
            )}
            {username === "superadmin" ? (
              <li className="nav-item">
                <button
                  className={`nav-link ${
                    activeTab === "org-permission" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("org-permission")}
                >
                  Permission
                </button>
              </li>
            ) : (
              <>
                <li className="nav-item">
                  <button
                    className={`nav-link ${
                      activeTab === "org-permission" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("org-permission")}
                  >
                    Permission
                  </button>
                </li>
              </>
            )}
            {username === "superadmin" ? (
              <li className="nav-item">
                <button
                  className={`nav-link ${
                    activeTab === "org-user-roles" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("org-user-roles")}
                >
                  User Roles
                </button>
              </li>
            ) : (
              <>
                <li className="nav-item">
                  <button
                    className={`nav-link ${
                      activeTab === "org-user-roles" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("org-user-roles")}
                  >
                    user Roles
                  </button>
                </li>
              </>
            )}
            {username === "superadmin" ? (
              <li className="nav-item">
                <button
                  className={`nav-link ${
                    activeTab === "org-user-permission" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("org-user-permission")}
                >
                  Role Permission
                </button>
              </li>
            ) : (
              <>
                <li className="nav-item">
                  <button
                    className={`nav-link ${
                      activeTab === "org-user-permission" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("org-user-permission")}
                  >
                    Role Permission
                  </button>
                </li>
              </>
            )}
          </ul>
          <div className="tab-content">
            {activeTab === "org-category" && (
              <div className="tab-pane active">{<NavCategoryList />}</div>
            )}
            {activeTab === "org-sub-category" && (
              <div className="tab-pane active">{<NavSubCategoryList />}</div>
            )}
            {activeTab === "org-form" && (
              <div className="tab-pane active">{<NavFormList />}</div>
            )}
            {activeTab === "org-permission" && (
              <div className="tab-pane active">{<PermissionList />}</div>
            )}
            {activeTab === "org-user-roles" && (
              <div className="tab-pane active">{<UserRoleList />}</div>
            )}
            {activeTab === "org-user-permission" && (
              <div className="tab-pane active">{<RolePermissionList />}</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default UserAuthMainSetup;
